<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  methods: {

    tagManagerAdd() {
      const tagManagerScript = document.createElement('script');
      tagManagerScript.async = true;
      tagManagerScript.setAttribute('data-cookieconsent', 'tag_manager-allowed');
      tagManagerScript.setAttribute(
        'data-src',
        'https://www.googletagmanager.com/gtag/js?id=AW-462031264',
      );
      document.head.appendChild(tagManagerScript);
    },

    tagManagerInit() {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'AW-462031264');
      gtag('config', 'G-XWRHEDR7RB');
    },
  },
  mounted() {
    this.tagManagerAdd();
    this.tagManagerInit();
  },
};
</script>
